export default __webpack_public_path__ + "static/space-704bc2a894983b1ae9cdd4a2a692eeda.png";